import { useTranslation } from "react-i18next";
import { Profile2User, MoneySend } from "iconsax-react";
import { formatMoneyKzt, type Locale } from "@/shared/utils";

interface Props {
  stats: {
    totalEmployees: number;
    totalSalary: number;
  };
}

export default function EmployeesSummaryCards({ stats }: Props) {
  const { t, i18n } = useTranslation("EmployeesPage");
  const locale = (i18n.language as Locale) || "ru";

  const cards = [
    {
      key: "total",
      label: t("summary.totalEmployees"),
      value: String(stats.totalEmployees),
      icon: Profile2User,
    },
    {
      key: "fund",
      label: t("summary.fund"),
      value: formatMoneyKzt(stats.totalSalary, locale),
      icon: MoneySend,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 mb-4">
      {cards.map(function renderCard(card) {
        const Icon = card.icon;
        return (
          <div key={card.key} className="surface-container-fill radius-3xl p-5 flex flex-col gap-3">
            <div className="flex justify-start items-center gap-2">
              <div className="w-8 h-8 radius-xs surface-component-fill flex items-center justify-center content-action-neutral shrink-0">
                <Icon size={16} color="currentColor" />
              </div>
              <p className="text-label-md content-base-primary">{card.label}</p>
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-display-sm content-base-primary">{card.value}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
